<template>
  <product-list
    :is-search-result="true"
    :product-list="productList"
    :facets="facets"
    :is-page-load="isPageLoad"
    :items-per-page="itemsPerPage"
    :current-page="currentPage"
    :is-recommended="true"
    :hide-filtering="hideFilter"
    @filter-changed="loadProductList"
    @sorting-changed="loadProductList"
    @clicked-load-more="loadProductList"
  />
</template>

<script>
import ProductList from '@/components/organisms/ShopCommerce/ProductList';
import { getUrlParameter, updateQueryStringParam } from '@/utils/query'

export default {
  name: 'SearchResultProducts',
  components: {
    ProductList
  },
  data () {
    return {
      isPageLoad: true,
      currentView: 'card',
      selectedSorting: JSON.stringify({
        orderBy: '',
        order: '',
      }),
      selectedFilters: [],
      currentPage: 1,
      itemsPerPage: 12,
      facets: null,
      productList: {
        items: []
      },
      hideFilter: true,
    }
  },
  computed: {
    culture () {
      return this.$store.getters['site/getCurrentCulture'];
    },
    productListGuid () {
      return this.$store.getters['content/content/getContent']?.meta?.id;
    },
    productResults () {
      return this.$store.getters['search/productSearch/getProducts'];
    }
  },
  async mounted () {
    // this.facets = await this.getCategoryFacets();
    await this.loadProductList({ filters: this.selectedFilters, sorting: this.selectedSorting, isReload: true});
  },
  methods: {
    // async getCategoryFacets () {
    //   let category = await this.$repositories.category.byGuid(this.productListGuid, this.culture);
    //   return category.facets;
    // },
    async loadProductList (props) {
      if (!this.$route?.query?.query) return;
      this.currentPage = props.isReload ? 1 : this.currentPage + 1;

      if (process.client) {
        if (props.isReload) {
          // Get current page number from URL
          this.currentPage = parseInt(getUrlParameter('page')) || this.currentPage;
        } else if (this.currentPage > 1) {
          // Update page number in URL
          updateQueryStringParam('page', this.currentPage)
        }
      }

      // let facetsString = this.facets ? Object.keys(this.facets).join('|') : '';
      let response = await this.$store.dispatch('search/productSearch/fetchSearchResults', {
        query: this.$route?.query?.query,
        culture:  this.culture,
        itemsPerPage: this.itemsPerPage,
        currentPage: this.currentPage,
        facets: '', // facetsString,
        orderBy: props.sorting?.orderBy,
        order: props.sorting?.order,
        filters: props.filters,
        startFromFirstPage: props.isReload
      });

      if(this.isPageLoad) {
        this.facets = response.facets;
        this.hideFilter = !this.$isNotNullOrUndefined(this.productResults) || (this.$isNotNullOrUndefined(this.productResults) && !this.productResults.totalItems > 0);
      }

      // Append to current list
      response.items = props.isReload ? [ ...response?.items ] : [ ...this.productList?.items, ...response?.items ]
      this.productList = response;

      // Scroll after the list has loaded
      if (this.isPageLoad) {
        this.goToScrollPosition();
      }

      this.isPageLoad = false;
    },
    goToScrollPosition () {
      if (process.client) {
        let position = getUrlParameter('position')
        if (position) {
          window.scrollTo({
            top: parseInt(position),
            behavior: 'smooth'
          })
        }
      }
    }
  },
}
</script>